import { Injectable } from '@angular/core';
import { WorkflowApiService } from '@selfai-platform/pipeline-api';
import { Observable } from 'rxjs';
import { WorkflowPresets } from '../../workflow-presets/interfaces/workflow-presets.interface';

@Injectable()
export class WorkflowSettingsPresetsDomainService {
  workflowSettingsPresets$: Observable<WorkflowPresets[]>;

  constructor(private readonly workflowApiService: WorkflowApiService) {}

  getItem(id: string): Observable<WorkflowPresets> {
    return this.workflowApiService.getPresetByWorkflowId(id);
  }
}
